<!-- 员工管理 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb :canBackHistory="true"></breadcrumb>
        </div>
        <el-container style="height: 700px">
            <el-header style="line-height: 30px; height: 45px">
                <el-checkbox v-model="needUpdate">打印修改订单</el-checkbox>
                <el-button v-if="!isStart" style="margin-left: 10px" type="primary" size="small" @click="startAutoPrint()">开始自动打印</el-button>
                <el-button v-if="isStart" style="margin-left: 10px" type="danger" size="small" @click="stopAutoPrint()">停止自动打印</el-button>
            </el-header>
            <el-container style="height: 100%">
                <el-aside width="25%" height="100%">
                    <el-card class="box-card b-screen" style="padding: 10px; height: 100%; overflow: auto">
                        <div>
                            <div class="w-content" style="color: red">
                                温馨提醒：当启动自动打印后，请勿关闭当前页面，关闭当前页面后将无法进行自动检测需要打印的订单。（仅检测当天单据）
                            </div>
                        </div>
                        <div class="p-content">
                            <div :class="isStart ? 'leida' : 'leida-png'"></div>
                        </div>
                        <div class="t-content">
                            <div>{{ isStart ? '检测中……' : '暂停检测中' }}</div>
                        </div>
                    </el-card>
                </el-aside>
                <el-main class="table-ctn" width="75%" height="100%" style="padding-top: 0px; padding-bottom: 0px">
                    <el-card class="box-card" style="padding: 15px; height: 100%; overflow: auto">
                        <el-table :header-cell-style="{ background: '#F2F6FC' }" :data="tableData" border="" style="width: 100%">
                            <el-table-column type="index" width="100px" label="序号" sortable></el-table-column>
                            <el-table-column min-width="190px" prop="OrderCode" label="销售单号" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="200px" prop="CusName" label="客户名称" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="160px" prop="CreateTime" label="单据日期" show-overflow-tooltip></el-table-column>
                            <el-table-column min-width="100px" prop="State" label="当前状态" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <i v-if="scope.row.State == 0" style="color: red">未打印</i>
                                    <i v-else-if="scope.row.State == 1">打印中……</i>
                                    <i v-else>-</i>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-main>
            </el-container>
        </el-container>
        <div style="visibility: hidden; width: 870px; position: absolute !important; top: -1000px !important" id="printDom" v-if="isRegister">
            <printContent ref="printDom" @closeDialog="closeDialog" :printIds="idList" :showDisc="false" :isInit="false"></printContent>
        </div>
    </div>
</template>
<script>
import breadcrumb from '@/components/common/breadcrumb';
import Vue from 'vue';
export default {
    mixins: [],
    name: '',
    components: {
        breadcrumb
    },
    data() {
        return {
            isStart: false,
            tableData: [],
            needUpdate: true,
            timeOut: null,
            printTimer: null,
            isRegister: false,
            idList: [],
            isAutoPrint: false
        };
    },
    mounted() {
        this.getAutoPrintConfig();
        this.getPrintComponents();
    },
    beforeDestroy() {
        if (this.timeOut) window.clearTimeout(this.timeOut);
        if (this.printTimer) window.clearTimeout(this.printTimer);
    },
    methods: {
        //获取中文打印模板
        getPrintComponents() {
            let that = this;
            that.$util.getPrintComponents().then(data => {
                if (data) {
                    Vue.component('printContent', () => import('@/components/printModels/' + data));
                    that.isRegister = true;
                } else {
                    Vue.component('printContent', () => import('@/components/printModels/printSales'));
                    that.isRegister = true;
                }
            });
        },
        startAutoPrint() {
            this.isStart = true;
            this.starTimer();
            this.startPrintTimer();
        },
        stopAutoPrint() {
            this.isStart = false;
            if (this.timeOut) window.clearTimeout(this.timeOut);
            if (this.printTimer) window.clearTimeout(this.printTimer);
        },
        getTableData() {
            let that = this;
            if (that.timeOut) {
                window.clearTimeout(that.timeOut);
            }
            return new Promise(resolve => {
                let url = '';
                if(that.isAutoPrint) url= '/api/EntpInfoManagement/GetSetPrintOrderData';
                else url= '/api/EntpInfoManagement/GetAutoPrintOrderData';
                that.$util
                    .axiosGet({
                        url: url,
                        data: {
                            needUpdate: that.needUpdate
                        },
                        hideLoading: true
                    })
                    .then(res => {
                        let data = res.data.DataList;
                        if (data) {
                            let tdata = that.tableData;
                            data.forEach(item => {
                                let sameData = tdata.find(e => e.OrderCode == item.OrderCode);
                                if (!sameData) {
                                    item.State = 0;
                                } else {
                                    if (sameData.State) item.State = sameData.State;
                                    else item.State = 0;
                                }
                            });
                            that.tableData = data;
                        }
                    })
                    .finally(() => {
                        resolve();
                    });
            });
        },
        starTimer() {
            this.getTableData().then(data => {
                this.requestAF(this.starTimer);
            });
        },
        requestAF(callback) {
            this.timeOut = window.setTimeout(callback, 10000);
        },
        dealPrintData() {
            let that = this;
            if (that.printTimer) {
                window.clearTimeout(that.printTimer);
            }
            return new Promise(resolve => {
                if (that.tableData.length > 0) {
                    try {
                        that.tableData.forEach(item => {
                            if (item.State == 0) {
                                that.idList.push(item.Id);
                                item.State = 1;
                                that.print();
                                throw new Error('End Loop');
                            }
                        });
                    } catch (e) {
                        //
                    }
                }
                resolve();
            });
        },
        startPrintTimer() {
            this.dealPrintData().then(() => {
                this.printAF(this.startPrintTimer);
            });
        },
        printAF(callback) {
            this.printTimer = window.setTimeout(callback, 15000);
        },
        print() {
            this.$refs.printDom.init(true);
        },
        closeDialog() {
            this.idList = [];
        },
        getAutoPrintConfig() {
            this.$util.getSysConfig('xsdjdybszddy').then(data => {
                this.isAutoPrint = data.Result;
            });
        },
    }
};
</script>
<style lang="less" scoped>
.leida {
    width: 250px;
    height: 200px;
    background-image: url(../../../assets/images/leida.gif);
    background-repeat: no-repeat;
    background-size: 250px 200px;
}
.leida-png {
    width: 250px;
    height: 200px;
    background-image: url(../../../assets/images/leida.png);
    background-repeat: no-repeat;
    background-size: 250px 200px;
}
.b-screen {
    display: flex;
    min-width: 270px;
    height: 100%;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    align-content: space-between;
}
.w-content {
    line-height: 26px;
}
.p-content {
    display: flex;
    width: 100%;
    height: 400px;
    justify-content: center;
    align-content: center;
    align-items: center;
}
.t-content {
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    width: 100%;
    font-size: 26px;
}
</style>
